import { DeleteButton, EditButton, getDefaultSortOrder, List, TextField, useTable } from "@refinedev/antd";
import { Space, Table } from "antd";

import { BlockedUrlInfo } from "interfaces";


export const BlockedUrlList: React.FC = () => {
  const { tableProps, sorters } = useTable<BlockedUrlInfo>({
    sorters: {
      initial: [{ field: "id", order: "desc" }]
    }
  });

  return (
    <List>
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="id"
          key="id"
          title="ID"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("id", sorters)}
          sorter
        />
        <Table.Column
          dataIndex="url"
          key="url"
          title="URL"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("url", sorters)}
          sorter
        />
        <Table.Column<BlockedUrlInfo>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <DeleteButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
